export default __webpack_public_path__ + "static/media/underline.9184bbd3.png";